import { Country } from '@tiendanube/common/src/enums';
import ShowByCountry from 'App/components/ShowByCountry';
import { NUVEMENVIO_CYBER_MONDAY_BANNER } from 'App/featuresFlags';
import { useResponsive } from 'commons/components';
import { useDismissibleComponent, useWhatsappMessageLink } from 'commons/hooks';
import { openWindow } from 'commons/utils/window';
import { useGetTags } from 'domains/Auth/hooks';
import {
  trackingNuvemEnvioCyberMondayBannerClick,
  trackingNuvemEnvioCyberMondayBannerClose,
} from 'domains/NuvemEnvioCommons/tracking';
import BannerDesktop from './components/BannerDesktop';
import BannerMobile from './components/BannerMobile';

const WHATSAPP_MESSAGE =
  'Hola, me gustaría recibir más información sobre Envío Nube.';

const WHATSAPP_PHONE = '+5491125713523';

function CyberMondayBanner() {
  const { isMobile: isMobileResponsive } = useResponsive();
  const getUrl = useWhatsappMessageLink();
  const hasCyberMondayBanner = useGetTags().includes(
    NUVEMENVIO_CYBER_MONDAY_BANNER,
  );

  const { shouldShow, dismiss } = useDismissibleComponent(
    'cyber-monday-banner-dismiss',
    90,
  );

  const handleClick = () => {
    trackingNuvemEnvioCyberMondayBannerClick();
    openWindow(
      getUrl({
        phone: WHATSAPP_PHONE,
        message: WHATSAPP_MESSAGE,
      }),
      true,
    );
  };

  const handleClose = () => {
    trackingNuvemEnvioCyberMondayBannerClose();
    dismiss();
  };

  if (!shouldShow || !hasCyberMondayBanner) {
    return null;
  }

  return (
    <ShowByCountry allowedCountries={[Country.AR]}>
      <>
        {isMobileResponsive && (
          <BannerMobile
            onClose={handleClose}
            onClick={handleClick}
            translateKey="cyberMondayBanner"
          />
        )}
        {!isMobileResponsive && (
          <BannerDesktop
            onClose={handleClose}
            onClick={handleClick}
            translateKey="cyberMondayBanner"
          />
        )}
      </>
    </ShowByCountry>
  );
}

export default CyberMondayBanner;
